/* eslint-disable camelcase */
export default {
    en: {
        declineDialog: {
            selectReason: {
                title: 'Why doesn\'t this work for you?',
                subtitle: 'This is optional, but your feedback helps us find better matches',
                reasons: {
                    availability: {
                        title: 'Not Available',
                        subtitle: 'I can\'t work during this period'
                    },
                    location: {
                        title: 'Wrong Location',
                        subtitle: 'Too far or inconvenient'
                    },
                    company: {
                        title: 'Wrong Company',
                        subtitle: 'I prefer other employers'
                    },
                    role: {
                        title: 'Wrong Role',
                        subtitle: 'Not what I\'m looking for'
                    },
                    skills: {
                        title: 'Wrong Skills',
                        subtitle: 'Not a good match'
                    },
                    schedule: {
                        title: 'Work Time Preferences',
                        subtitle: 'The working hours don\'t fit'
                    },
                    other: {
                        title: 'Not Interested',
                        subtitle: 'Other reasons'
                    }
                }
            },
            setReasonDetails: {
                title: 'Optional details',
                subtitle: 'This helps us suggest better matches',
                reasonInput: {
                    availability: {
                        label: 'When will you be available?',
                        startDate: 'Start date',
                        endDate: 'End date'
                    },
                    location: {
                        label: 'Preferred location'
                    },
                    role: {
                        label: 'Which role were you expecting?',
                        specialtyLabel: 'Which speciality were you expecting?'
                    },
                    skills: {
                        label: 'Your skills'
                    },
                    schedule: {
                        label: 'Quick selections',
                        shortcuts: [
                            {
                                label: 'Night shifts',
                                value: 'I prefer night shifts.'
                            },
                            {
                                label: 'Day shifts',
                                value: 'I prefer day shifts.'
                            },
                            {
                                label: 'No weekends',
                                value: 'I\'m not available on weekends.'
                            },
                            {
                                label: 'Part-time',
                                value: 'I\'m looking for part-time work.'
                            },
                            {
                                label: '6-12 months',
                                value: 'I\'m open to assignments lasting 6-12 months.'
                            },
                            {
                                label: '12+ months',
                                value: 'I\'m open to assignments lasting 12+ months.'
                            },
                            {
                                label: 'Permanent/Full-time positions only',
                                value: 'I\'m open to full-time assignments only.'
                            }
                        ]
                    }
                },
                freeText: {
                    title: 'Anything else you\'d like to add?',
                    label: 'Additional notes',
                    placeholder: 'Any additional information that would help us find better matches...'
                },
                actions: {
                    chooseDifferentReason: 'Choose a different reason',
                    submit: 'Send Feedback'
                }
            }
        },
        generalDialog: {
            title: 'Share feedback or ask a question',
            subtitle: 'What would you like us to know? Share your thoughts about this opportunity',
            freeText: {
                label: 'Your feedback',
                placeholder: 'Share feedback, ask a question, or tell us what you\'re looking for',
                validationRequired: 'Feedback is required.'
            },
            actions: {
                cancel: 'Cancel',
                submit: 'Submit feedback'
            },
            sentSuccess: 'Thank you for your feedback!'
        },
        button: {
            leaveFeedback: 'Leave feedback'
        },
        toast: {
            success: 'Thank you for your feedback!',
            error: 'Failed to send feedback. Please try again.'
        }
    },
    no: {
        declineDialog: {
            selectReason: {
                title: 'Hvorfor passer ikke dette for deg?',
                subtitle: 'Dette er valgfritt, men tilbakemeldingen din hjelper oss å finne bedre matcher',
                reasons: {
                    availability: {
                        title: 'Ikke tilgjengelig',
                        subtitle: 'Jeg kan ikke jobbe i denne perioden'
                    },
                    location: {
                        title: 'Feil sted',
                        subtitle: 'For langt eller upraktisk'
                    },
                    company: {
                        title: 'Feil selskap',
                        subtitle: 'Jeg foretrekker andre arbeidsgivere'
                    },
                    role: {
                        title: 'Feil rolle',
                        subtitle: 'Ikke det jeg ser etter'
                    },
                    skills: {
                        title: 'Feil kompetanse',
                        subtitle: 'Passer ikke'
                    },
                    schedule: {
                        title: 'Arbeidstidspreferanser',
                        subtitle: 'Arbeidstidene passer ikke'
                    },
                    other: {
                        title: 'Ikke interessert',
                        subtitle: 'Andre grunner'
                    }
                }
            },
            setReasonDetails: {
                title: 'Valgfrie detaljer',
                subtitle: 'Dette hjelper oss å foreslå bedre matcher',
                reasonInput: {
                    availability: {
                        label: 'Når er du tilgjengelig?',
                        startDate: 'Startdato',
                        endDate: 'Sluttdato'
                    },
                    location: {
                        label: 'Foretrukket sted'
                    },
                    role: {
                        label: 'Hvilken rolle forventet du?',
                        specialtyLabel: 'Hvilken spesialitet forventet du?'
                    },
                    skills: {
                        label: 'Din kompetanse'
                    },
                    schedule: {
                        label: 'Hurtigvalg',
                        shortcuts: [
                            {
                                label: 'Nattskift',
                                value: 'Jeg foretrekker nattskift.'
                            },
                            {
                                label: 'Dagskift',
                                value: 'Jeg foretrekker dagskift.'
                            },
                            {
                                label: 'Ingen helger',
                                value: 'Jeg er ikke tilgjengelig i helgene.'
                            },
                            {
                                label: 'Deltid',
                                value: 'Jeg ser etter deltidsarbeid.'
                            },
                            {
                                label: '6-12 måneder',
                                value: 'Jeg er åpen for oppdrag som varer 6-12 måneder.'
                            },
                            {
                                label: '12+ måneder',
                                value: 'Jeg er åpen for oppdrag som varer 12+ måneder.'
                            },
                            {
                                label: 'Kun fast/heltidsstillinger',
                                value: 'Jeg er kun åpen for heltidsoppdrag.'
                            }
                        ]
                    }
                },
                freeText: {
                    title: 'Er det noe annet du vil legge til?',
                    label: 'Tilleggsnotater',
                    placeholder: 'Ytterligere informasjon som kan hjelpe oss å finne bedre matcher...'
                },
                actions: {
                    chooseDifferentReason: 'Velg en annen grunn',
                    submit: 'Send tilbakemelding'
                }
            }
        },
        generalDialog: {
            title: 'Del tilbakemelding eller still et spørsmål',
            subtitle: 'Hva vil du at vi skal vite? Del dine tanker om denne muligheten',
            freeText: {
                label: 'Din tilbakemelding',
                placeholder: 'Del tilbakemelding, still et spørsmål, eller fortell oss hva du ser etter',
                validationRequired: 'Tilbakemelding er påkrevd.'
            },
            actions: {
                cancel: 'Avbryt',
                submit: 'Send tilbakemelding'
            },
            sentSuccess: 'Takk for tilbakemeldingen din!'
        },
        button: {
            leaveFeedback: 'Gi tilbakemelding'
        },
        toast: {
            success: 'Takk for tilbakemeldingen!',
            error: 'Kunne ikke sende tilbakemelding. Vennligst prøv igjen.'
        }
    },
    sv: {
        declineDialog: {
            selectReason: {
                title: 'Varför passar inte detta för dig?',
                subtitle: 'Detta är valfritt, men din feedback hjälper oss hitta bättre matchningar',
                reasons: {
                    availability: {
                        title: 'Inte tillgänglig',
                        subtitle: 'Jag kan inte jobba under denna period'
                    },
                    location: {
                        title: 'Fel plats',
                        subtitle: 'För långt eller opraktiskt'
                    },
                    company: {
                        title: 'Fel företag',
                        subtitle: 'Jag föredrar andra arbetsgivare'
                    },
                    role: {
                        title: 'Fel roll',
                        subtitle: 'Inte vad jag letar efter'
                    },
                    skills: {
                        title: 'Fel kompetens',
                        subtitle: 'Passar inte'
                    },
                    schedule: {
                        title: 'Arbetstidspreferenser',
                        subtitle: 'Arbetstiderna passar inte'
                    },
                    other: {
                        title: 'Inte intresserad',
                        subtitle: 'Andra skäl'
                    }
                }
            },
            setReasonDetails: {
                title: 'Valfria detaljer',
                subtitle: 'Detta hjälper oss föreslå bättre matchningar',
                reasonInput: {
                    availability: {
                        label: 'När är du tillgänglig?',
                        startDate: 'Startdatum',
                        endDate: 'Slutdatum'
                    },
                    location: {
                        label: 'Föredragen plats'
                    },
                    role: {
                        label: 'Vilken roll förväntade du dig?',
                        specialtyLabel: 'Vilken specialitet förväntade du dig?'
                    },
                    skills: {
                        label: 'Din kompetens'
                    },
                    schedule: {
                        label: 'Snabbval',
                        shortcuts: [
                            {
                                label: 'Nattskift',
                                value: 'Jag föredrar nattskift.'
                            },
                            {
                                label: 'Dagskift',
                                value: 'Jag föredrar dagskift.'
                            },
                            {
                                label: 'Inga helger',
                                value: 'Jag är inte tillgänglig på helger.'
                            },
                            {
                                label: 'Deltid',
                                value: 'Jag letar efter deltidsarbete.'
                            },
                            {
                                label: '6-12 månader',
                                value: 'Jag är öppen för uppdrag som varar 6-12 månader.'
                            },
                            {
                                label: '12+ månader',
                                value: 'Jag är öppen för uppdrag som varar 12+ månader.'
                            },
                            {
                                label: 'Endast fasta/heltidstjänster',
                                value: 'Jag är endast öppen för heltidsuppdrag.'
                            }
                        ]
                    }
                },
                freeText: {
                    title: 'Något annat du vill lägga till?',
                    label: 'Ytterligare anteckningar',
                    placeholder: 'Ytterligare information som kan hjälpa oss hitta bättre matchningar...'
                },
                actions: {
                    chooseDifferentReason: 'Välj ett annat skäl',
                    submit: 'Skicka feedback'
                }
            }
        },
        generalDialog: {
            title: 'Dela feedback eller ställ en fråga',
            subtitle: 'Vad vill du att vi ska veta? Dela dina tankar om denna möjlighet',
            freeText: {
                label: 'Din feedback',
                placeholder: 'Dela feedback, ställ en fråga, eller berätta vad du letar efter',
                validationRequired: 'Feedback krävs.'
            },
            actions: {
                cancel: 'Avbryt',
                submit: 'Skicka feedback'
            },
            sentSuccess: 'Tack för din feedback!'
        },
        button: {
            leaveFeedback: 'Lämna feedback'
        },
        toast: {
            success: 'Tack för din feedback!',
            error: 'Kunde inte skicka feedback. Försök igen.'
        }
    }
} as const;
